import { StyleSheet } from 'react-native'

export default StyleSheet.create({
    wrapper: {
        flexDirection: 'row'
    },
    xAxis: {
        width: '100%'
        , borderTopWidth: 1
        , borderTopColor: '#e0e0e0'
    },
    xAxisLabels: {
        width: '100%'
        , paddingVertical: 10
        , height: 10
    },
    yAxis: {
        borderRightWidth: 1
        , borderColor: '#e0e0e0'
        , width: 1
        , height: '100%'
        , marginRight: 0
    },
    yAxisLabelsWrapper: {
        paddingRight: 5
    },
    chartViewWrapper: {
        flexDirection: 'row'
        , alignItems: 'flex-end'
        , margin: 0
        , paddingRight: 0
    },
    coordinateWrapper: {
        overflow: 'hidden'
        , justifyContent: 'flex-start'
        , alignContent: 'flex-start'
    },
    lineBox: {
        justifyContent: 'flex-start'
    },
    drawGuideLine: {
        width: '100%'
        , height: '100%'
        , position: 'absolute'
    },
    guideLine: {
        position: 'absolute'
        , height: '100%'
        , borderRightColor: '#e0e0e050'
        , borderRightWidth: 1
    },
    absolute: {
        position: 'absolute'
        , width: '100%'
    },
    pointWrapper: {
        position: 'absolute'
        , borderRadius: 10
        , borderWidth: 1
    },
    selectedWrapper: {
        position: 'absolute'
        , height: '100%'
        , alignItems: 'flex-start'
    },
    selectedLine: {
        position: 'absolute'
        , width: 1
        , height: '100%'
    },
    selectedBox: {
        backgroundColor: '#FFFFFF'
        , borderRadius: 5
        , opacity: 0.8
        , borderColor: '#AAAAAA'
        , borderWidth: 1
        , position: 'absolute'
        , padding: 3
        , marginLeft: 5
        , justifyContent: 'center'
    },
    tooltipTitle: {
        fontSize: 10
    },
    tooltipValue: {
        fontWeight: 'bold'
        , fontSize: 15
    }
})



// WEBPACK FOOTER //
// ./src/components/charts/styles.js